import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    userName: '',
    deptName: '',
    deptId: '',
    avatar: '',
    userId: '',
    sex: '',
    phone: ''
  }),
  actions: {
  }
})